import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { FeaturePot } from "./FeaturePot";

export class FeaturePotComponent extends AbstractDisplayComponent {
    public container: FeaturePot;

    public override init() {
        let containerConfig = {
            labelName: "feature_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 0,
                posY: 0,
                scale: 1,
            },
            portrait: {
                posX: 0,
                posY: 0,
                scale: 1,
            }
        };
        super.init();
        this.container = new FeaturePot(containerConfig);
    }

    public getInstance(): FeaturePot {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

}